import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParamsOfBooking } from "../../hooks/searchParams/useSearchParamsOfBooking";
import { useBookingState } from "../../hooks/useBookingState";
import { useProdaName } from "../../hooks/useProdaName";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import QuantityBookCardSectionAges from "./QuantityBookCardSectionAges";
import { QuatityBookingRow } from "./QuatityBookingRow";

export const QuantityBookCardSection: React.FC<
  {
    type?: "ROW" | "CARD";
    min?: number;
  } & ProdAttrPickerModeProps
> = ({ type = "ROW", min, ...props }) => {
  const { isUpgrade: isUpgradeRaw, isEdit } = useSearchParamsOfBooking();
  const isUpgrade = (isUpgradeRaw || isEdit) && props.mode === "FORM";
  const { t } = useTranslation();
  const { prodaName } = useProdaName();
  const bookingAttributes = useBookingState({
    mode: props.mode,
  }).bookingAttributes;
  const names: ProdAttrName[] =
    props.mode === "POPUP"
      ? ["ROOM"] // , "Q_SIM"
      : ["ADULT", "CHILD", "PERSON", "Q_SIM", "ROOM"];
  const isPass = props.d?.productType === "PASS";
  const renderLs = names.flatMap((name) => {
    if (name === "CHILD") {
      return (
        <QuantityBookCardSectionAges
          disabled={isUpgrade}
          key={"age"}
          type={type}
          {...props}
        />
      );
    }
    return [
      ...bookingAttributes
        .filter((y) => y.productAttribute.name === name)
        .map((x) => {
          return (
            <QuatityBookingRow
              disabled={isUpgrade}
              min={min || name === "Q_SIM" ? 1 : 0}
              bookingAttributes={bookingAttributes}
              mode={props.mode}
              key={x?.productAttribute.id ?? ""}
              type={type}
              dto={x!}
              label={prodaName(x?.productAttribute!)}
              d={props.d}
            />
          );
        }),
    ].filter((x) => x);
  });
  if (renderLs.length === 0) return null;
  const minAdult = ProdAttrUtils.findMinAdult(bookingAttributes);
  return (
    <div className="mb-4">
      <p
        className={clsx(
          "mb-4 flex w-full items-baseline text-sm font-normal text-[#5E6D77]",
          props.mode === "POPUP" ? "" : "sm:text-base sm:leading-[1.5rem]",
        )}
      >
        {t("Select Quantity")}
        {isPass &&
          ProdAttrUtils.findDefaultBooka(
            bookingAttributes,
          )?.value?.ageQuantities?.[0]?.age?.includes("CHILD") && (
            <span className="ml-[8px] inline-block text-[13px] leading-[18px] text-[#5E6D77]">
              ※{" "}
              {t(
                "Options may vary by child age. Please select each child individually",
              )}
            </span>
          )}

        {!!minAdult && (
          <span className="ml-auto inline-block text-[13px] leading-[18px] text-[#5E6D77]">
            {t("Minimum number of guest is", {
              num: minAdult,
            })}
          </span>
        )}
      </p>
      <div
        className={clsx(
          "grid grid-cols-1 gap-4",
          props.mode === "POPUP"
            ? "pr-40 md:grid-cols-1"
            : isPass
              ? "!flex max-w-[560px] flex-wrap sm:flex-nowrap"
              : "lg:grid-cols-3",
        )}
      >
        {renderLs}
      </div>
    </div>
  );
};
